import Vue from "vue";
import Vuetify from "vuetify/lib";
import en from "vuetify/src/locale/en";
import es from "vuetify/src/locale/es";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#72237C",
        secondary: "#00A0C6",
        accent: "#FF6800",
        error: "#b71c1c",
        success: "#008B05",
        green: "#008B5C",
        blueMedium: "#58A0D5",
      },
    },
  },
  icons: {
    iconfont: "mdiSvg", // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4' || 'faSvg'
  },
  lang: {
    locales: { en, es },
    current: "es",
  },
});
